import {Component, Input} from '@angular/core';
import {User} from '../../model/auth/User';

@Component({
  selector: 'students-passwords',
  templateUrl: './students-passwords-table.component.html',
  styleUrls: ['./students-passwords-table.component.scss']
})
export class StudentsPasswordsTableComponent {
  @Input() users: User[] = [];
  @Input() changePassResults?: Map<string, string>;

}
